/**
 * Sunset Liquor – Welcome Discount Popup
 * Watches for the Yes button click on the age gate,
 * hides the age gate, then shows the discount popup.
 */
var SL_DISCOUNT_CODE   = 'SAVE5';
var SL_DISCOUNT_AMOUNT = '$5';

(function () {
  'use strict';

  /* ── Inject styles ── */
  var style = document.createElement('style');
  style.textContent = [
    '#sl-overlay{',
      'position:fixed;inset:0;z-index:2147483647;',
      'display:none;align-items:center;justify-content:center;',
      'background:rgba(240,230,225,0.88);',
    '}',
    '#sl-overlay.sl-visible{display:flex;}',

    '#sl-card{',
      'background:#fff;',
      'border-radius:18px;',
      'padding:48px 40px 36px;',
      'max-width:420px;width:92%;',
      'text-align:center;',
      'position:relative;',
      'box-shadow:0 16px 60px rgba(0,0,0,0.18);',
      'animation:slIn .4s cubic-bezier(.22,1,.36,1) both;',
    '}',
    '@keyframes slIn{from{transform:translateY(30px) scale(0.96);opacity:0}to{transform:none;opacity:1}}',

    '#sl-close{',
      'position:absolute;top:14px;right:16px;',
      'background:none;border:none;cursor:pointer;',
      'color:#ccc;font-size:22px;line-height:1;padding:4px 8px;',
      'transition:color .2s;',
    '}',
    '#sl-close:hover{color:#C81E28;}',

    '#sl-badge{',
      'display:inline-block;',
      'background:rgba(200,30,40,0.07);',
      'color:#C81E28;',
      'font-size:10px;font-weight:700;letter-spacing:2.5px;',
      'padding:6px 18px;border-radius:30px;',
      'margin-bottom:20px;text-transform:uppercase;',
      'border:1px solid rgba(200,30,40,0.18);',
    '}',

    '#sl-headline{',
      'color:#111;',
      'font-size:clamp(28px,5vw,36px);',
      'font-weight:800;margin:0 0 8px;line-height:1.1;',
      'font-family:Georgia,"Times New Roman",serif;',
      'text-transform:uppercase;',
    '}',
    '#sl-headline span{color:#C81E28;}',
    '#sl-sub{color:#888;font-size:13px;margin:10px 0 26px;line-height:1.65;}',

    '#sl-code-box{',
      'background:#fafafa;border:1.5px dashed rgba(200,30,40,0.35);',
      'border-radius:12px;padding:20px 18px 16px;margin-bottom:16px;',
    '}',
    '#sl-code-label{color:#bbb;font-size:10px;letter-spacing:2.5px;text-transform:uppercase;margin:0 0 8px;}',
    '#sl-code-text{color:#111;font-size:28px;font-weight:700;letter-spacing:5px;margin:0 0 14px;font-family:"Courier New",monospace;}',

    '#sl-copy-btn{',
      'background:#C81E28;color:#fff;border:none;border-radius:8px;',
      'padding:13px 0;font-size:12px;font-weight:700;letter-spacing:1.8px;',
      'cursor:pointer;text-transform:uppercase;width:100%;',
      'display:flex;align-items:center;justify-content:center;gap:8px;',
      'transition:background .2s;',
    '}',
    '#sl-copy-btn:hover{background:#a51820;}',
    '#sl-copy-btn svg{width:14px;height:14px;fill:currentColor;}',

    '#sl-shop-btn{',
      'display:block;width:100%;box-sizing:border-box;',
      'background:transparent;color:#C81E28;',
      'border:1.5px solid rgba(200,30,40,0.3);border-radius:8px;padding:13px;',
      'font-size:12px;font-weight:700;letter-spacing:1.8px;',
      'cursor:pointer;text-transform:uppercase;margin-bottom:16px;',
      'transition:border-color .2s,background .2s;',
    '}',
    '#sl-shop-btn:hover{border-color:#C81E28;background:rgba(200,30,40,0.04);}',
    '#sl-fine{color:#ddd;font-size:11px;margin:0;}',

    '#sl-success{display:none;padding:10px 0 6px;}',
    '#sl-success-icon{width:62px;height:62px;background:rgba(200,30,40,0.07);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 18px;border:1px solid rgba(200,30,40,0.18);font-size:26px;}',
    '#sl-success h3{color:#111;font-size:20px;font-family:Georgia,serif;font-weight:700;margin:0 0 8px;letter-spacing:1px;text-transform:uppercase;}',
    '#sl-success p{color:#888;font-size:13px;margin:0;line-height:1.65;}',
    '#sl-success p strong{color:#C81E28;font-family:monospace;letter-spacing:3px;}',

    '@media(max-width:480px){#sl-card{padding:40px 24px 28px;}#sl-headline{font-size:24px;}}',
  ].join('');
  document.head.appendChild(style);

  /* ── Build HTML ── */
  var overlay = document.createElement('div');
  overlay.id = 'sl-overlay';
  overlay.innerHTML = [
    '<div id="sl-card">',
      '<button id="sl-close" aria-label="Close">&#x2715;</button>',
      '<div id="sl-main">',
        '<div id="sl-badge">Welcome to Sunset Liquor</div>',
        '<h2 id="sl-headline">GET <span>' + SL_DISCOUNT_AMOUNT + ' OFF</span><br>YOUR FIRST ORDER</h2>',
        '<p id="sl-sub">Est. 1993 &nbsp;&middot;&nbsp; Over 50,000 happy customers<br>Your exclusive welcome discount is ready.</p>',
        '<div id="sl-code-box">',
          '<p id="sl-code-label">Your Discount Code</p>',
          '<p id="sl-code-text">' + SL_DISCOUNT_CODE + '</p>',
          '<button id="sl-copy-btn">',
            '<svg viewBox="0 0 24 24"><path d="M16 1H4a2 2 0 00-2 2v14h2V3h12V1zm3 4H8a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2zm0 16H8V7h11v14z"/></svg>',
            '<span id="sl-copy-label">Copy Code</span>',
          '</button>',
        '</div>',
        '<button id="sl-shop-btn">Start Shopping &nbsp;&rarr;</button>',
        '<p id="sl-fine">One use per customer &nbsp;&middot;&nbsp; Valid on first order only</p>',
      '</div>',
      '<div id="sl-success">',
        '<div id="sl-success-icon">&#10003;</div>',
        '<h3>Code Copied!</h3>',
        '<p>Paste <strong>' + SL_DISCOUNT_CODE + '</strong> at checkout<br>to save ' + SL_DISCOUNT_AMOUNT + ' on your first order.</p>',
      '</div>',
    '</div>',
  ].join('');
  document.body.appendChild(overlay);

  /* ── Helpers ── */
  function hideAllAgeGates() {
    /* Hide every common age gate element */
    var selectors = [
      '#agp__root',
      '#agp__noPeekScreen',
      '[id*="age"]',
      '[class*="age-gate"]',
      '[class*="age-verif"]',
      '[class*="agegate"]',
      '[class*="AgeCheck"]',
      '.age-verification',
    ];
    selectors.forEach(function(sel) {
      try {
        document.querySelectorAll(sel).forEach(function(el) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
        });
      } catch(e) {}
    });
    /* Restore scroll */
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function showPopup() {
    if (localStorage.getItem('sl_discount_shown')) return;
    localStorage.setItem('sl_discount_shown', '1');
    hideAllAgeGates();
    /* Reset state */
    document.getElementById('sl-main').style.display = '';
    document.getElementById('sl-success').style.display = 'none';
    overlay.classList.add('sl-visible');
  }

  function hidePopup() {
    overlay.classList.remove('sl-visible');
  }

  /* ── Buttons ── */
  document.getElementById('sl-copy-btn').addEventListener('click', function () {
    var label = document.getElementById('sl-copy-label');
    var btn   = document.getElementById('sl-copy-btn');
    navigator.clipboard.writeText(SL_DISCOUNT_CODE).catch(function () {
      var ta = document.createElement('textarea');
      ta.value = SL_DISCOUNT_CODE;
      ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
      document.body.appendChild(ta); ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    });
    label.textContent = 'Copied!';
    btn.style.background = '#166534';
    setTimeout(function () { label.textContent = 'Copy Code'; btn.style.background = '#C81E28'; }, 2500);
  });

  document.getElementById('sl-shop-btn').addEventListener('click', function () {
    document.getElementById('sl-main').style.display = 'none';
    document.getElementById('sl-success').style.display = 'block';
    setTimeout(hidePopup, 2000);
  });

  document.getElementById('sl-close').addEventListener('click', function(e) {
    e.stopPropagation(); hidePopup();
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hidePopup();
  });

  /* ────────────────────────────────────────────────────────────
     TRIGGER: Watch for any "Yes" button click inside the age gate.
     Works by scanning for buttons containing "yes" text every
     500ms until found, then attaches a click listener.
  ──────────────────────────────────────────────────────────── */
  function findAndWatchYesButton() {
    /* Already triggered — stop */
    if (localStorage.getItem('sl_discount_shown')) return;

    var root = document.getElementById('agp__root');
    var container = root || document.body;

    var buttons = container.querySelectorAll('button, input[type="button"], a[role="button"], [role="button"]');
    var found = false;

    buttons.forEach(function(btn) {
      var text = (btn.textContent || btn.value || btn.innerText || '').trim().toLowerCase();
      if (text === 'yes' || text === 'yes, i am' || text === 'enter' || text === 'i am of age' || text.indexOf('yes') === 0) {
        if (!btn._slWatched) {
          btn._slWatched = true;
          found = true;
          btn.addEventListener('click', function() {
            setTimeout(showPopup, 350);
          });
        }
      }
    });

    /* Also hook into the Age Checker official API if available */
    if (window.agechecker_developer_api && typeof window.agechecker_developer_api.on === 'function') {
      if (!window._slAgeApiHooked) {
        window._slAgeApiHooked = true;
        ['pass', 'verified', 'success', 'confirm', 'allowed'].forEach(function(evt) {
          window.agechecker_developer_api.on(evt, function() {
            setTimeout(showPopup, 350);
          });
        });
      }
    }

    /* Keep scanning until the age gate appears and Yes button is found */
    if (!found) {
      setTimeout(findAndWatchYesButton, 500);
    }
  }

  /* Start watching as soon as DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndWatchYesButton);
  } else {
    findAndWatchYesButton();
  }

})();